import gameStates from '../_states.json'

let timeout = null

export default {
    namespaced: true,
    state: {
        fps: 1000/3,
        state: gameStates.stop,
        states: gameStates,
        startAt: 0,
        time: 0,
        minute: 0,
        currentAt: 0,
        pauseTime: 0,
        pauseStartAt: 0
    },
    actions: {
        start ({state, commit, dispatch}) {
            commit('run')
            if (!timeout) {
                timeout = setTimeout(() => dispatch('update'), state.fps)
            }
        },

        stop ({dispatch}) {
            clearTimeout(timeout)
            timeout = null
            dispatch('reset', null, {root: true})
        },

        pause ({state, commit}) {
            clearTimeout(timeout)
            timeout = null
            if (state.state !== state.states.stop && state.state !== state.states.pause) {
                commit('pause')
            }
        },

        update ({state, commit, dispatch}) {
            if (state.state === state.states.run) {
                commit('update')
                dispatch('update', null, {root: true})
                timeout = setTimeout(() => dispatch('update'), state.fps)
            }
        },

        reset ({commit}) {
            clearTimeout(timeout)
            timeout = null
            commit('reset')
        }
    },
    mutations: {
        run (state) {
            const time = Date.now()

            if (state.pauseStartAt) {
                state.pauseTime += Date.now() - state.pauseStartAt
                state.pauseStartAt = 0
            }

            if (state.state === state.states.stop) {
                state.startAt = time
            }

            state.currentAt = time
            state.state = state.states.run
        },

        reset (state) {
            state.state = state.states.stop
            state.startAt = 0
            state.currentAt = 0
            state.time = 0
            state.minute = 0
            state.pauseTime = 0
            state.pauseStartAt = 0
        },

        pause (state) {
            state.state = state.states.pause
            state.pauseStartAt = Date.now()
        },

        update (state) {
            const time = state.currentAt - state.startAt - state.pauseTime
            state.currentAt = Date.now()
            state.time = time
            state.minute = Math.ceil(time / (60 * 1000))
        }
    }
}
